import { toast } from './LoadingUtil';
/**
 * 判断是否是合法的手机号码
 * @param  {String}  phoneNumber [手机号码]
 * @return {Boolean}             [true为合法]
 */
export const isMobile = (phoneNumber) => {
    //phoneNumber为空
    if(!phoneNumber) {
        return false;
    }
    // 将第一个+86去掉
    phoneNumber = phoneNumber.replace("+86", "");
    // 正则表达式的规则（1开头，第二位为34578中任意一个，后面跟着9位数字）
    let pattern = new RegExp('^[1][34587]\\d{9}$');
    return pattern.test(phoneNumber);
};

export const isEmail = (email) => {
  if(!email) {
    return false;
  }
  let pattern = new RegExp('^[A-Za-z\\d]+([-_.][A-Za-z\\d]+)*@([A-Za-z\\d]+[-.])+[A-Za-z\\d]{2,4}$');
  return pattern.test(email);
};

export const validateIdno = (idno, birthdate) => {
  let reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
        const _birthdate = (idno || '').slice(6, 14);
        const __birthdate = (birthdate || '').replace(/-/g, '');
        if (!reg.test(idno)) {
          toast('请输入正确的身份证号');
          return false;
        } else if (_birthdate !== __birthdate){
          toast('生日与身份证号不符')
          return false;
        }
        return true;
}


// WEBPACK FOOTER //
// ./src/libs/CheckUtil.js